module.exports = __webpack_public_path__ + "static/media/portfolio.278f5b03.PNG";